<template>
    <div id="legal-frame">
        <div class="container is-max-desktop legal-card">

            <div class="legal-body">
                <div class="legal-head">
                    <router-link to="/" class="brand"><strong>my</strong>247ed.com</router-link>
                    <b-button tag="router-link" :to="backTo" size="is-small" outlined icon-left="arrow-left">{{ backLabel }}</b-button>
                </div>

                <h2 class="legal-title">{{ title }}</h2>
                <p class="legal-effective" v-if="effective">Effective {{ legal.effectiveDate }}</p>
                <div v-else class="mb-5"></div>

                <div class="content">
                    <slot :legal="legal"></slot>
                </div>

                <hr/>

                <div class="legal-foot is-size-7">
                    <router-link to="/terms">Terms of Use</router-link>
                    <span class="mx-2">·</span>
                    <router-link to="/privacy">Privacy Policy</router-link>
                    <span class="mx-2">·</span>
                    <a :href="`mailto:${legal.supportEmail}`">{{ legal.supportEmail }}</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {LEGAL} from '@/constants/legal';

    export default {
        name: 'LegalPage',
        props: {
            title: {type: String, required: true},
            // Legal documents show their effective date; other pages in this frame don't
            effective: {type: Boolean, default: true},
        },
        data() {
            return {legal: LEGAL};
        },
        computed: {
            loggedIn() {
                return !!this.$store.getters.currentUser;
            },
            backTo() {
                return this.loggedIn ? {name: 'account', params: {section: 'account'}} : '/';
            },
            backLabel() {
                return this.loggedIn ? 'Back to Account' : 'Return to Login';
            },
        },
    };
</script>

<style lang="scss">
    #legal-frame {
        min-height: 100vh;
        padding: 4rem 2rem 8rem;
        background: #224C74 radial-gradient(#336699, #1e385c);

        .legal-card {
            background-color: #FFFFFF;
            border-radius: 8px;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        }

        .legal-body {
            padding: 3.5rem;
            color: #555555;
        }

        .legal-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 2rem;

            .brand {
                font-size: 1.8rem;
                color: #282828;
                letter-spacing: -1px;

                strong {
                    color: #336699;
                    font-weight: 900;
                }
            }
        }

        .legal-title {
            font-size: 1.6rem;
            font-weight: 600;
            color: #282828;
            margin-bottom: 0.25rem;
        }

        .legal-effective {
            font-size: 0.85rem;
            color: #888888;
            margin-bottom: 2rem;
        }

        .content {
            h3 {
                font-size: 1.1rem;
                color: #336699;
                margin-top: 2rem;
                padding-bottom: 0.5rem;
                border-bottom: 1px dashed #ddd;
            }

            h4 {
                font-size: 0.95rem;
                margin-top: 1.25rem;
            }

            strong {
                color: #484848;
            }
        }

        .legal-foot {
            text-align: center;
            color: #888888;
        }

        @media (max-width: 768px) {
            padding: 0;

            .legal-card {
                border-radius: 0;
                box-shadow: none;
            }

            .legal-body {
                padding: 2rem 1rem 3rem;
            }

            .legal-head .brand {
                font-size: 1.4rem;
            }
        }
    }
</style>
